export default "__VITE_ASSET__CFlpWrHq__"